export default function initHeadersAnimations() {
  const gsapLoadInterval = setInterval(() => {
    if (gsap !== undefined) {
      clearInterval(gsapLoadInterval);
      gsap.registerPlugin(ScrollTrigger);
      new SplitType("[text-split]", { types: "words, chars", tagName: "span" });

      function createScrollTrigger(element, timeline) {
        ScrollTrigger.create({
          trigger: element,
          start: "top 90%",
          onEnter: () => timeline.play(),
        });
      }

      document.querySelectorAll("[words-slide-up]").forEach((element) => {
        let timeline = gsap.timeline({ paused: true });
        timeline.from(element.querySelectorAll(".word"), {
          opacity: 0,
          yPercent: 60,
          duration: 1.5,
          ease: "power2.out",
          stagger: { amount: 0.5 },
        });
        createScrollTrigger(element, timeline);
      });

      document
        .querySelectorAll("[words-slide-up-preload]")
        .forEach((element) => {
          let timeline = gsap.timeline({ paused: true });
          timeline.from(element.querySelectorAll(".word"), {
            opacity: 0,
            yPercent: 60,
            duration: 0.7,
            ease: "power2.out",
            stagger: { amount: 0.5 },
          });
          createScrollTrigger(element, timeline);
        });

      gsap.set("[text-split]", { opacity: 1 });
    }
  }, 50);
}
